import { render, staticRenderFns } from "./PendingDeposit.vue?vue&type=template&id=4ff98256&"
import script from "./PendingDeposit.vue?vue&type=script&lang=ts&"
export * from "./PendingDeposit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports